import React from 'react';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
}));

export default function NotificationSnackbar(props) {
    const classes = useStyles();
    // const [setOpen] = React.useState(false);

    // const handleClick = () => {
    //     setOpen(true);
    // };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        return;
        // setOpen(false);
    };

    return (
        <div className={classes.root}>

            <Snackbar open={props.show} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={props.color}>
                    {props.text}
                </Alert>
            </Snackbar>
        </div>
    );
}
